/* eslint-disable */

import {YearlyHolidays} from "../model";

/**
 * Yearly holidays.
 */

export const yearlyHolidaysYears =
[
  {
    "year": 2014,
    "holidays": {
      "newYearsDay": {
        "date": "2014-01-01",
        "holiday": "newYearsDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "uudenvuodenpäivä",
        "name": "New Year's Day"
      },
      "epiphany": {
        "date": "2014-01-06",
        "holiday": "epiphany",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "loppiainen",
        "name": "Epiphany"
      },
      "goodFriday": {
        "date": "2014-04-18",
        "holiday": "goodFriday",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "pitkäperjantai",
        "name": "Good Friday"
      },
      "easterSaturday": {
        "date": "2014-04-19",
        "holiday": "easterSaturday",
        "holidayGroups": [
          "nonBanking",
          "holiday"
        ],
        "localName": "pääsiäislauantai",
        "name": "Easter Saturday"
      },
      "easterSunday": {
        "date": "2014-04-20",
        "holiday": "easterSunday",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "pääsiäispäivä",
        "name": "Easter Sunday"
      },
      "easterMonday": {
        "date": "2014-04-21",
        "holiday": "easterMonday",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "2. pääsiäispäivä",
        "name": "Easter Monday"
      },
      "mayDay": {
        "date": "2014-05-01",
        "holiday": "mayDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "vappu",
        "name": "May Day"
      },
      "ascensionDay": {
        "date": "2014-05-29",
        "holiday": "ascensionDay",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "helatorstai",
        "name": "Ascension Day"
      },
      "pentecost": {
        "date": "2014-06-08",
        "holiday": "pentecost",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "helluntaipäivä",
        "name": "Pentecost"
      },
      "midsummerEve": {
        "date": "2014-06-20",
        "holiday": "midsummerEve",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "juhannusaatto",
        "name": "Midsummer Eve"
      },
      "midsummerDay": {
        "date": "2014-06-21",
        "holiday": "midsummerDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "juhannuspäivä",
        "name": "Midsummer Day"
      },
      "allSaintsDay": {
        "date": "2014-11-22",
        "holiday": "allSaintsDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "pyhäinpäivä",
        "name": "All Saints' Day"
      },
      "independenceDay": {
        "date": "2014-12-06",
        "holiday": "independenceDay",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "itsenäisyyspäivä",
        "name": "Independence Day"
      },
      "christmasEve": {
        "date": "2014-12-24",
        "holiday": "christmasEve",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "jouluaatto",
        "name": "Christmas Eve"
      },
      "christmasDay": {
        "date": "2014-12-25",
        "holiday": "christmasDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "joulupäivä",
        "name": "Christmas Day"
      },
      "stStephensDay": {
        "date": "2014-12-26",
        "holiday": "stStephensDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "2. joulupäivä",
        "name": "St. Stephen's Day"
      }
    }
  },
  {
    "year": 2015,
    "holidays": {
      "newYearsDay": {
        "date": "2015-01-01",
        "holiday": "newYearsDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "uudenvuodenpäivä",
        "name": "New Year's Day"
      },
      "epiphany": {
        "date": "2015-01-06",
        "holiday": "epiphany",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "loppiainen",
        "name": "Epiphany"
      },
      "goodFriday": {
        "date": "2015-04-03",
        "holiday": "goodFriday",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "pitkäperjantai",
        "name": "Good Friday"
      },
      "easterSaturday": {
        "date": "2015-04-04",
        "holiday": "easterSaturday",
        "holidayGroups": [
          "nonBanking",
          "holiday"
        ],
        "localName": "pääsiäislauantai",
        "name": "Easter Saturday"
      },
      "easterSunday": {
        "date": "2015-04-05",
        "holiday": "easterSunday",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "pääsiäispäivä",
        "name": "Easter Sunday"
      },
      "easterMonday": {
        "date": "2015-04-06",
        "holiday": "easterMonday",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "2. pääsiäispäivä",
        "name": "Easter Monday"
      },
      "mayDay": {
        "date": "2015-05-01",
        "holiday": "mayDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "vappu",
        "name": "May Day"
      },
      "ascensionDay": {
        "date": "2015-05-14",
        "holiday": "ascensionDay",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "helatorstai",
        "name": "Ascension Day"
      },
      "pentecost": {
        "date": "2015-05-24",
        "holiday": "pentecost",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "helluntaipäivä",
        "name": "Pentecost"
      },
      "midsummerEve": {
        "date": "2015-06-19",
        "holiday": "midsummerEve",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "juhannusaatto",
        "name": "Midsummer Eve"
      },
      "midsummerDay": {
        "date": "2015-06-20",
        "holiday": "midsummerDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "juhannuspäivä",
        "name": "Midsummer Day"
      },
      "allSaintsDay": {
        "date": "2015-11-21",
        "holiday": "allSaintsDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "pyhäinpäivä",
        "name": "All Saints' Day"
      },
      "independenceDay": {
        "date": "2015-12-06",
        "holiday": "independenceDay",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "itsenäisyyspäivä",
        "name": "Independence Day"
      },
      "christmasEve": {
        "date": "2015-12-24",
        "holiday": "christmasEve",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "jouluaatto",
        "name": "Christmas Eve"
      },
      "christmasDay": {
        "date": "2015-12-25",
        "holiday": "christmasDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "joulupäivä",
        "name": "Christmas Day"
      },
      "stStephensDay": {
        "date": "2015-12-26",
        "holiday": "stStephensDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "2. joulupäivä",
        "name": "St. Stephen's Day"
      }
    }
  },
  {
    "year": 2016,
    "holidays": {
      "newYearsDay": {
        "date": "2016-01-01",
        "holiday": "newYearsDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "uudenvuodenpäivä",
        "name": "New Year's Day"
      },
      "epiphany": {
        "date": "2016-01-06",
        "holiday": "epiphany",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "loppiainen",
        "name": "Epiphany"
      },
      "goodFriday": {
        "date": "2016-03-25",
        "holiday": "goodFriday",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "pitkäperjantai",
        "name": "Good Friday"
      },
      "easterSaturday": {
        "date": "2016-03-26",
        "holiday": "easterSaturday",
        "holidayGroups": [
          "nonBanking",
          "holiday"
        ],
        "localName": "pääsiäislauantai",
        "name": "Easter Saturday"
      },
      "easterSunday": {
        "date": "2016-03-27",
        "holiday": "easterSunday",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "pääsiäispäivä",
        "name": "Easter Sunday"
      },
      "easterMonday": {
        "date": "2016-03-28",
        "holiday": "easterMonday",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "2. pääsiäispäivä",
        "name": "Easter Monday"
      },
      "mayDay": {
        "date": "2016-05-01",
        "holiday": "mayDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "vappu",
        "name": "May Day"
      },
      "ascensionDay": {
        "date": "2016-05-05",
        "holiday": "ascensionDay",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "helatorstai",
        "name": "Ascension Day"
      },
      "pentecost": {
        "date": "2016-05-15",
        "holiday": "pentecost",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "helluntaipäivä",
        "name": "Pentecost"
      },
      "midsummerEve": {
        "date": "2016-06-24",
        "holiday": "midsummerEve",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "juhannusaatto",
        "name": "Midsummer Eve"
      },
      "midsummerDay": {
        "date": "2016-06-25",
        "holiday": "midsummerDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "juhannuspäivä",
        "name": "Midsummer Day"
      },
      "allSaintsDay": {
        "date": "2016-11-19",
        "holiday": "allSaintsDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "pyhäinpäivä",
        "name": "All Saints' Day"
      },
      "independenceDay": {
        "date": "2016-12-06",
        "holiday": "independenceDay",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "itsenäisyyspäivä",
        "name": "Independence Day"
      },
      "christmasEve": {
        "date": "2016-12-24",
        "holiday": "christmasEve",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "jouluaatto",
        "name": "Christmas Eve"
      },
      "christmasDay": {
        "date": "2016-12-25",
        "holiday": "christmasDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "joulupäivä",
        "name": "Christmas Day"
      },
      "stStephensDay": {
        "date": "2016-12-26",
        "holiday": "stStephensDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "2. joulupäivä",
        "name": "St. Stephen's Day"
      }
    }
  },
  {
    "year": 2017,
    "holidays": {
      "newYearsDay": {
        "date": "2017-01-01",
        "holiday": "newYearsDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "uudenvuodenpäivä",
        "name": "New Year's Day"
      },
      "epiphany": {
        "date": "2017-01-06",
        "holiday": "epiphany",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "loppiainen",
        "name": "Epiphany"
      },
      "goodFriday": {
        "date": "2017-04-14",
        "holiday": "goodFriday",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "pitkäperjantai",
        "name": "Good Friday"
      },
      "easterSaturday": {
        "date": "2017-04-15",
        "holiday": "easterSaturday",
        "holidayGroups": [
          "nonBanking",
          "holiday"
        ],
        "localName": "pääsiäislauantai",
        "name": "Easter Saturday"
      },
      "easterSunday": {
        "date": "2017-04-16",
        "holiday": "easterSunday",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "pääsiäispäivä",
        "name": "Easter Sunday"
      },
      "easterMonday": {
        "date": "2017-04-17",
        "holiday": "easterMonday",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "2. pääsiäispäivä",
        "name": "Easter Monday"
      },
      "mayDay": {
        "date": "2017-05-01",
        "holiday": "mayDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "vappu",
        "name": "May Day"
      },
      "ascensionDay": {
        "date": "2017-05-25",
        "holiday": "ascensionDay",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "helatorstai",
        "name": "Ascension Day"
      },
      "pentecost": {
        "date": "2017-06-04",
        "holiday": "pentecost",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "helluntaipäivä",
        "name": "Pentecost"
      },
      "midsummerEve": {
        "date": "2017-06-23",
        "holiday": "midsummerEve",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "juhannusaatto",
        "name": "Midsummer Eve"
      },
      "midsummerDay": {
        "date": "2017-06-24",
        "holiday": "midsummerDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "juhannuspäivä",
        "name": "Midsummer Day"
      },
      "allSaintsDay": {
        "date": "2017-11-25",
        "holiday": "allSaintsDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "pyhäinpäivä",
        "name": "All Saints' Day"
      },
      "independenceDay": {
        "date": "2017-12-06",
        "holiday": "independenceDay",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "itsenäisyyspäivä",
        "name": "Independence Day"
      },
      "christmasEve": {
        "date": "2017-12-24",
        "holiday": "christmasEve",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "jouluaatto",
        "name": "Christmas Eve"
      },
      "christmasDay": {
        "date": "2017-12-25",
        "holiday": "christmasDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "joulupäivä",
        "name": "Christmas Day"
      },
      "stStephensDay": {
        "date": "2017-12-26",
        "holiday": "stStephensDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "2. joulupäivä",
        "name": "St. Stephen's Day"
      }
    }
  },
  {
    "year": 2018,
    "holidays": {
      "newYearsDay": {
        "date": "2018-01-01",
        "holiday": "newYearsDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "uudenvuodenpäivä",
        "name": "New Year's Day"
      },
      "epiphany": {
        "date": "2018-01-06",
        "holiday": "epiphany",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "loppiainen",
        "name": "Epiphany"
      },
      "goodFriday": {
        "date": "2018-03-30",
        "holiday": "goodFriday",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "pitkäperjantai",
        "name": "Good Friday"
      },
      "easterSaturday": {
        "date": "2018-03-31",
        "holiday": "easterSaturday",
        "holidayGroups": [
          "nonBanking",
          "holiday"
        ],
        "localName": "pääsiäislauantai",
        "name": "Easter Saturday"
      },
      "easterSunday": {
        "date": "2018-04-01",
        "holiday": "easterSunday",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "pääsiäispäivä",
        "name": "Easter Sunday"
      },
      "easterMonday": {
        "date": "2018-04-02",
        "holiday": "easterMonday",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "2. pääsiäispäivä",
        "name": "Easter Monday"
      },
      "mayDay": {
        "date": "2018-05-01",
        "holiday": "mayDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "vappu",
        "name": "May Day"
      },
      "ascensionDay": {
        "date": "2018-05-10",
        "holiday": "ascensionDay",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "helatorstai",
        "name": "Ascension Day"
      },
      "pentecost": {
        "date": "2018-05-20",
        "holiday": "pentecost",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "helluntaipäivä",
        "name": "Pentecost"
      },
      "midsummerEve": {
        "date": "2018-06-22",
        "holiday": "midsummerEve",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "juhannusaatto",
        "name": "Midsummer Eve"
      },
      "midsummerDay": {
        "date": "2018-06-23",
        "holiday": "midsummerDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "juhannuspäivä",
        "name": "Midsummer Day"
      },
      "allSaintsDay": {
        "date": "2018-11-24",
        "holiday": "allSaintsDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "pyhäinpäivä",
        "name": "All Saints' Day"
      },
      "independenceDay": {
        "date": "2018-12-06",
        "holiday": "independenceDay",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "itsenäisyyspäivä",
        "name": "Independence Day"
      },
      "christmasEve": {
        "date": "2018-12-24",
        "holiday": "christmasEve",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "jouluaatto",
        "name": "Christmas Eve"
      },
      "christmasDay": {
        "date": "2018-12-25",
        "holiday": "christmasDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "joulupäivä",
        "name": "Christmas Day"
      },
      "stStephensDay": {
        "date": "2018-12-26",
        "holiday": "stStephensDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "2. joulupäivä",
        "name": "St. Stephen's Day"
      }
    }
  },
  {
    "year": 2019,
    "holidays": {
      "newYearsDay": {
        "date": "2019-01-01",
        "holiday": "newYearsDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "uudenvuodenpäivä",
        "name": "New Year's Day"
      },
      "epiphany": {
        "date": "2019-01-06",
        "holiday": "epiphany",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "loppiainen",
        "name": "Epiphany"
      },
      "goodFriday": {
        "date": "2019-04-19",
        "holiday": "goodFriday",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "pitkäperjantai",
        "name": "Good Friday"
      },
      "easterSaturday": {
        "date": "2019-04-20",
        "holiday": "easterSaturday",
        "holidayGroups": [
          "nonBanking",
          "holiday"
        ],
        "localName": "pääsiäislauantai",
        "name": "Easter Saturday"
      },
      "easterSunday": {
        "date": "2019-04-21",
        "holiday": "easterSunday",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "pääsiäispäivä",
        "name": "Easter Sunday"
      },
      "easterMonday": {
        "date": "2019-04-22",
        "holiday": "easterMonday",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "2. pääsiäispäivä",
        "name": "Easter Monday"
      },
      "mayDay": {
        "date": "2019-05-01",
        "holiday": "mayDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "vappu",
        "name": "May Day"
      },
      "ascensionDay": {
        "date": "2019-05-30",
        "holiday": "ascensionDay",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "helatorstai",
        "name": "Ascension Day"
      },
      "pentecost": {
        "date": "2019-06-09",
        "holiday": "pentecost",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "helluntaipäivä",
        "name": "Pentecost"
      },
      "midsummerEve": {
        "date": "2019-06-21",
        "holiday": "midsummerEve",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "juhannusaatto",
        "name": "Midsummer Eve"
      },
      "midsummerDay": {
        "date": "2019-06-22",
        "holiday": "midsummerDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "juhannuspäivä",
        "name": "Midsummer Day"
      },
      "allSaintsDay": {
        "date": "2019-11-23",
        "holiday": "allSaintsDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "pyhäinpäivä",
        "name": "All Saints' Day"
      },
      "independenceDay": {
        "date": "2019-12-06",
        "holiday": "independenceDay",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "itsenäisyyspäivä",
        "name": "Independence Day"
      },
      "christmasEve": {
        "date": "2019-12-24",
        "holiday": "christmasEve",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "jouluaatto",
        "name": "Christmas Eve"
      },
      "christmasDay": {
        "date": "2019-12-25",
        "holiday": "christmasDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "joulupäivä",
        "name": "Christmas Day"
      },
      "stStephensDay": {
        "date": "2019-12-26",
        "holiday": "stStephensDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "2. joulupäivä",
        "name": "St. Stephen's Day"
      }
    }
  },
  {
    "year": 2020,
    "holidays": {
      "newYearsDay": {
        "date": "2020-01-01",
        "holiday": "newYearsDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "uudenvuodenpäivä",
        "name": "New Year's Day"
      },
      "epiphany": {
        "date": "2020-01-06",
        "holiday": "epiphany",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "loppiainen",
        "name": "Epiphany"
      },
      "goodFriday": {
        "date": "2020-04-10",
        "holiday": "goodFriday",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "pitkäperjantai",
        "name": "Good Friday"
      },
      "easterSaturday": {
        "date": "2020-04-11",
        "holiday": "easterSaturday",
        "holidayGroups": [
          "nonBanking",
          "holiday"
        ],
        "localName": "pääsiäislauantai",
        "name": "Easter Saturday"
      },
      "easterSunday": {
        "date": "2020-04-12",
        "holiday": "easterSunday",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "pääsiäispäivä",
        "name": "Easter Sunday"
      },
      "easterMonday": {
        "date": "2020-04-13",
        "holiday": "easterMonday",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "2. pääsiäispäivä",
        "name": "Easter Monday"
      },
      "mayDay": {
        "date": "2020-05-01",
        "holiday": "mayDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "vappu",
        "name": "May Day"
      },
      "ascensionDay": {
        "date": "2020-05-21",
        "holiday": "ascensionDay",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "helatorstai",
        "name": "Ascension Day"
      },
      "pentecost": {
        "date": "2020-05-31",
        "holiday": "pentecost",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "helluntaipäivä",
        "name": "Pentecost"
      },
      "midsummerEve": {
        "date": "2020-06-19",
        "holiday": "midsummerEve",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "juhannusaatto",
        "name": "Midsummer Eve"
      },
      "midsummerDay": {
        "date": "2020-06-20",
        "holiday": "midsummerDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "juhannuspäivä",
        "name": "Midsummer Day"
      },
      "allSaintsDay": {
        "date": "2020-11-21",
        "holiday": "allSaintsDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "pyhäinpäivä",
        "name": "All Saints' Day"
      },
      "independenceDay": {
        "date": "2020-12-06",
        "holiday": "independenceDay",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "itsenäisyyspäivä",
        "name": "Independence Day"
      },
      "christmasEve": {
        "date": "2020-12-24",
        "holiday": "christmasEve",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "jouluaatto",
        "name": "Christmas Eve"
      },
      "christmasDay": {
        "date": "2020-12-25",
        "holiday": "christmasDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "joulupäivä",
        "name": "Christmas Day"
      },
      "stStephensDay": {
        "date": "2020-12-26",
        "holiday": "stStephensDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "2. joulupäivä",
        "name": "St. Stephen's Day"
      }
    }
  },
  {
    "year": 2021,
    "holidays": {
      "newYearsDay": {
        "date": "2021-01-01",
        "holiday": "newYearsDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "uudenvuodenpäivä",
        "name": "New Year's Day"
      },
      "epiphany": {
        "date": "2021-01-06",
        "holiday": "epiphany",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "loppiainen",
        "name": "Epiphany"
      },
      "goodFriday": {
        "date": "2021-04-02",
        "holiday": "goodFriday",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "pitkäperjantai",
        "name": "Good Friday"
      },
      "easterSaturday": {
        "date": "2021-04-03",
        "holiday": "easterSaturday",
        "holidayGroups": [
          "nonBanking",
          "holiday"
        ],
        "localName": "pääsiäislauantai",
        "name": "Easter Saturday"
      },
      "easterSunday": {
        "date": "2021-04-04",
        "holiday": "easterSunday",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "pääsiäispäivä",
        "name": "Easter Sunday"
      },
      "easterMonday": {
        "date": "2021-04-05",
        "holiday": "easterMonday",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "2. pääsiäispäivä",
        "name": "Easter Monday"
      },
      "mayDay": {
        "date": "2021-05-01",
        "holiday": "mayDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "vappu",
        "name": "May Day"
      },
      "ascensionDay": {
        "date": "2021-05-13",
        "holiday": "ascensionDay",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "helatorstai",
        "name": "Ascension Day"
      },
      "pentecost": {
        "date": "2021-05-23",
        "holiday": "pentecost",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "helluntaipäivä",
        "name": "Pentecost"
      },
      "midsummerEve": {
        "date": "2021-06-25",
        "holiday": "midsummerEve",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "juhannusaatto",
        "name": "Midsummer Eve"
      },
      "midsummerDay": {
        "date": "2021-06-26",
        "holiday": "midsummerDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "juhannuspäivä",
        "name": "Midsummer Day"
      },
      "allSaintsDay": {
        "date": "2021-11-20",
        "holiday": "allSaintsDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "pyhäinpäivä",
        "name": "All Saints' Day"
      },
      "independenceDay": {
        "date": "2021-12-06",
        "holiday": "independenceDay",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "itsenäisyyspäivä",
        "name": "Independence Day"
      },
      "christmasEve": {
        "date": "2021-12-24",
        "holiday": "christmasEve",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "jouluaatto",
        "name": "Christmas Eve"
      },
      "christmasDay": {
        "date": "2021-12-25",
        "holiday": "christmasDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "joulupäivä",
        "name": "Christmas Day"
      },
      "stStephensDay": {
        "date": "2021-12-26",
        "holiday": "stStephensDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "2. joulupäivä",
        "name": "St. Stephen's Day"
      }
    }
  },
  {
    "year": 2022,
    "holidays": {
      "newYearsDay": {
        "date": "2022-01-01",
        "holiday": "newYearsDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "uudenvuodenpäivä",
        "name": "New Year's Day"
      },
      "epiphany": {
        "date": "2022-01-06",
        "holiday": "epiphany",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "loppiainen",
        "name": "Epiphany"
      },
      "goodFriday": {
        "date": "2022-04-15",
        "holiday": "goodFriday",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "pitkäperjantai",
        "name": "Good Friday"
      },
      "easterSaturday": {
        "date": "2022-04-16",
        "holiday": "easterSaturday",
        "holidayGroups": [
          "nonBanking",
          "holiday"
        ],
        "localName": "pääsiäislauantai",
        "name": "Easter Saturday"
      },
      "easterSunday": {
        "date": "2022-04-17",
        "holiday": "easterSunday",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "pääsiäispäivä",
        "name": "Easter Sunday"
      },
      "easterMonday": {
        "date": "2022-04-18",
        "holiday": "easterMonday",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "2. pääsiäispäivä",
        "name": "Easter Monday"
      },
      "mayDay": {
        "date": "2022-05-01",
        "holiday": "mayDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "vappu",
        "name": "May Day"
      },
      "ascensionDay": {
        "date": "2022-05-26",
        "holiday": "ascensionDay",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "helatorstai",
        "name": "Ascension Day"
      },
      "pentecost": {
        "date": "2022-06-05",
        "holiday": "pentecost",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "helluntaipäivä",
        "name": "Pentecost"
      },
      "midsummerEve": {
        "date": "2022-06-24",
        "holiday": "midsummerEve",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "juhannusaatto",
        "name": "Midsummer Eve"
      },
      "midsummerDay": {
        "date": "2022-06-25",
        "holiday": "midsummerDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "juhannuspäivä",
        "name": "Midsummer Day"
      },
      "allSaintsDay": {
        "date": "2022-11-19",
        "holiday": "allSaintsDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "pyhäinpäivä",
        "name": "All Saints' Day"
      },
      "independenceDay": {
        "date": "2022-12-06",
        "holiday": "independenceDay",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "itsenäisyyspäivä",
        "name": "Independence Day"
      },
      "christmasEve": {
        "date": "2022-12-24",
        "holiday": "christmasEve",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "jouluaatto",
        "name": "Christmas Eve"
      },
      "christmasDay": {
        "date": "2022-12-25",
        "holiday": "christmasDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "joulupäivä",
        "name": "Christmas Day"
      },
      "stStephensDay": {
        "date": "2022-12-26",
        "holiday": "stStephensDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "2. joulupäivä",
        "name": "St. Stephen's Day"
      }
    }
  },
  {
    "year": 2023,
    "holidays": {
      "newYearsDay": {
        "date": "2023-01-01",
        "holiday": "newYearsDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "uudenvuodenpäivä",
        "name": "New Year's Day"
      },
      "epiphany": {
        "date": "2023-01-06",
        "holiday": "epiphany",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "loppiainen",
        "name": "Epiphany"
      },
      "goodFriday": {
        "date": "2023-04-07",
        "holiday": "goodFriday",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "pitkäperjantai",
        "name": "Good Friday"
      },
      "easterSaturday": {
        "date": "2023-04-08",
        "holiday": "easterSaturday",
        "holidayGroups": [
          "nonBanking",
          "holiday"
        ],
        "localName": "pääsiäislauantai",
        "name": "Easter Saturday"
      },
      "easterSunday": {
        "date": "2023-04-09",
        "holiday": "easterSunday",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "pääsiäispäivä",
        "name": "Easter Sunday"
      },
      "easterMonday": {
        "date": "2023-04-10",
        "holiday": "easterMonday",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "2. pääsiäispäivä",
        "name": "Easter Monday"
      },
      "mayDay": {
        "date": "2023-05-01",
        "holiday": "mayDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "vappu",
        "name": "May Day"
      },
      "ascensionDay": {
        "date": "2023-05-18",
        "holiday": "ascensionDay",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "helatorstai",
        "name": "Ascension Day"
      },
      "pentecost": {
        "date": "2023-05-28",
        "holiday": "pentecost",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "helluntaipäivä",
        "name": "Pentecost"
      },
      "midsummerEve": {
        "date": "2023-06-23",
        "holiday": "midsummerEve",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "juhannusaatto",
        "name": "Midsummer Eve"
      },
      "midsummerDay": {
        "date": "2023-06-24",
        "holiday": "midsummerDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "juhannuspäivä",
        "name": "Midsummer Day"
      },
      "allSaintsDay": {
        "date": "2023-11-25",
        "holiday": "allSaintsDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "pyhäinpäivä",
        "name": "All Saints' Day"
      },
      "independenceDay": {
        "date": "2023-12-06",
        "holiday": "independenceDay",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "itsenäisyyspäivä",
        "name": "Independence Day"
      },
      "christmasEve": {
        "date": "2023-12-24",
        "holiday": "christmasEve",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "jouluaatto",
        "name": "Christmas Eve"
      },
      "christmasDay": {
        "date": "2023-12-25",
        "holiday": "christmasDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "joulupäivä",
        "name": "Christmas Day"
      },
      "stStephensDay": {
        "date": "2023-12-26",
        "holiday": "stStephensDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "2. joulupäivä",
        "name": "St. Stephen's Day"
      }
    }
  },
  {
    "year": 2024,
    "holidays": {
      "newYearsDay": {
        "date": "2024-01-01",
        "holiday": "newYearsDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "uudenvuodenpäivä",
        "name": "New Year's Day"
      },
      "epiphany": {
        "date": "2024-01-06",
        "holiday": "epiphany",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "loppiainen",
        "name": "Epiphany"
      },
      "goodFriday": {
        "date": "2024-03-29",
        "holiday": "goodFriday",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "pitkäperjantai",
        "name": "Good Friday"
      },
      "easterSaturday": {
        "date": "2024-03-30",
        "holiday": "easterSaturday",
        "holidayGroups": [
          "nonBanking",
          "holiday"
        ],
        "localName": "pääsiäislauantai",
        "name": "Easter Saturday"
      },
      "easterSunday": {
        "date": "2024-03-31",
        "holiday": "easterSunday",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "pääsiäispäivä",
        "name": "Easter Sunday"
      },
      "easterMonday": {
        "date": "2024-04-01",
        "holiday": "easterMonday",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "2. pääsiäispäivä",
        "name": "Easter Monday"
      },
      "mayDay": {
        "date": "2024-05-01",
        "holiday": "mayDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "vappu",
        "name": "May Day"
      },
      "ascensionDay": {
        "date": "2024-05-09",
        "holiday": "ascensionDay",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "helatorstai",
        "name": "Ascension Day"
      },
      "pentecost": {
        "date": "2024-05-19",
        "holiday": "pentecost",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "helluntaipäivä",
        "name": "Pentecost"
      },
      "midsummerEve": {
        "date": "2024-06-21",
        "holiday": "midsummerEve",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "juhannusaatto",
        "name": "Midsummer Eve"
      },
      "midsummerDay": {
        "date": "2024-06-22",
        "holiday": "midsummerDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "juhannuspäivä",
        "name": "Midsummer Day"
      },
      "allSaintsDay": {
        "date": "2024-11-23",
        "holiday": "allSaintsDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "pyhäinpäivä",
        "name": "All Saints' Day"
      },
      "independenceDay": {
        "date": "2024-12-06",
        "holiday": "independenceDay",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "itsenäisyyspäivä",
        "name": "Independence Day"
      },
      "christmasEve": {
        "date": "2024-12-24",
        "holiday": "christmasEve",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "jouluaatto",
        "name": "Christmas Eve"
      },
      "christmasDay": {
        "date": "2024-12-25",
        "holiday": "christmasDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "joulupäivä",
        "name": "Christmas Day"
      },
      "stStephensDay": {
        "date": "2024-12-26",
        "holiday": "stStephensDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "2. joulupäivä",
        "name": "St. Stephen's Day"
      }
    }
  },
  {
    "year": 2025,
    "holidays": {
      "newYearsDay": {
        "date": "2025-01-01",
        "holiday": "newYearsDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "uudenvuodenpäivä",
        "name": "New Year's Day"
      },
      "epiphany": {
        "date": "2025-01-06",
        "holiday": "epiphany",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "loppiainen",
        "name": "Epiphany"
      },
      "goodFriday": {
        "date": "2025-04-18",
        "holiday": "goodFriday",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "pitkäperjantai",
        "name": "Good Friday"
      },
      "easterSaturday": {
        "date": "2025-04-19",
        "holiday": "easterSaturday",
        "holidayGroups": [
          "nonBanking",
          "holiday"
        ],
        "localName": "pääsiäislauantai",
        "name": "Easter Saturday"
      },
      "easterSunday": {
        "date": "2025-04-20",
        "holiday": "easterSunday",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "pääsiäispäivä",
        "name": "Easter Sunday"
      },
      "easterMonday": {
        "date": "2025-04-21",
        "holiday": "easterMonday",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "2. pääsiäispäivä",
        "name": "Easter Monday"
      },
      "mayDay": {
        "date": "2025-05-01",
        "holiday": "mayDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "vappu",
        "name": "May Day"
      },
      "ascensionDay": {
        "date": "2025-05-29",
        "holiday": "ascensionDay",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "helatorstai",
        "name": "Ascension Day"
      },
      "pentecost": {
        "date": "2025-06-08",
        "holiday": "pentecost",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "helluntaipäivä",
        "name": "Pentecost"
      },
      "midsummerEve": {
        "date": "2025-06-20",
        "holiday": "midsummerEve",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "juhannusaatto",
        "name": "Midsummer Eve"
      },
      "midsummerDay": {
        "date": "2025-06-21",
        "holiday": "midsummerDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "juhannuspäivä",
        "name": "Midsummer Day"
      },
      "allSaintsDay": {
        "date": "2025-11-22",
        "holiday": "allSaintsDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "pyhäinpäivä",
        "name": "All Saints' Day"
      },
      "independenceDay": {
        "date": "2025-12-06",
        "holiday": "independenceDay",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "itsenäisyyspäivä",
        "name": "Independence Day"
      },
      "christmasEve": {
        "date": "2025-12-24",
        "holiday": "christmasEve",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "jouluaatto",
        "name": "Christmas Eve"
      },
      "christmasDay": {
        "date": "2025-12-25",
        "holiday": "christmasDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "joulupäivä",
        "name": "Christmas Day"
      },
      "stStephensDay": {
        "date": "2025-12-26",
        "holiday": "stStephensDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "2. joulupäivä",
        "name": "St. Stephen's Day"
      }
    }
  },
  {
    "year": 2026,
    "holidays": {
      "newYearsDay": {
        "date": "2026-01-01",
        "holiday": "newYearsDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "uudenvuodenpäivä",
        "name": "New Year's Day"
      },
      "epiphany": {
        "date": "2026-01-06",
        "holiday": "epiphany",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "loppiainen",
        "name": "Epiphany"
      },
      "goodFriday": {
        "date": "2026-04-03",
        "holiday": "goodFriday",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "pitkäperjantai",
        "name": "Good Friday"
      },
      "easterSaturday": {
        "date": "2026-04-04",
        "holiday": "easterSaturday",
        "holidayGroups": [
          "nonBanking",
          "holiday"
        ],
        "localName": "pääsiäislauantai",
        "name": "Easter Saturday"
      },
      "easterSunday": {
        "date": "2026-04-05",
        "holiday": "easterSunday",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "pääsiäispäivä",
        "name": "Easter Sunday"
      },
      "easterMonday": {
        "date": "2026-04-06",
        "holiday": "easterMonday",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "2. pääsiäispäivä",
        "name": "Easter Monday"
      },
      "mayDay": {
        "date": "2026-05-01",
        "holiday": "mayDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "vappu",
        "name": "May Day"
      },
      "ascensionDay": {
        "date": "2026-05-14",
        "holiday": "ascensionDay",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "helatorstai",
        "name": "Ascension Day"
      },
      "pentecost": {
        "date": "2026-05-24",
        "holiday": "pentecost",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "helluntaipäivä",
        "name": "Pentecost"
      },
      "midsummerEve": {
        "date": "2026-06-19",
        "holiday": "midsummerEve",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "juhannusaatto",
        "name": "Midsummer Eve"
      },
      "midsummerDay": {
        "date": "2026-06-20",
        "holiday": "midsummerDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "juhannuspäivä",
        "name": "Midsummer Day"
      },
      "allSaintsDay": {
        "date": "2026-11-21",
        "holiday": "allSaintsDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "pyhäinpäivä",
        "name": "All Saints' Day"
      },
      "independenceDay": {
        "date": "2026-12-06",
        "holiday": "independenceDay",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "itsenäisyyspäivä",
        "name": "Independence Day"
      },
      "christmasEve": {
        "date": "2026-12-24",
        "holiday": "christmasEve",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "jouluaatto",
        "name": "Christmas Eve"
      },
      "christmasDay": {
        "date": "2026-12-25",
        "holiday": "christmasDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "joulupäivä",
        "name": "Christmas Day"
      },
      "stStephensDay": {
        "date": "2026-12-26",
        "holiday": "stStephensDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "2. joulupäivä",
        "name": "St. Stephen's Day"
      }
    }
  },
  {
    "year": 2027,
    "holidays": {
      "newYearsDay": {
        "date": "2027-01-01",
        "holiday": "newYearsDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "uudenvuodenpäivä",
        "name": "New Year's Day"
      },
      "epiphany": {
        "date": "2027-01-06",
        "holiday": "epiphany",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "loppiainen",
        "name": "Epiphany"
      },
      "goodFriday": {
        "date": "2027-03-26",
        "holiday": "goodFriday",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "pitkäperjantai",
        "name": "Good Friday"
      },
      "easterSaturday": {
        "date": "2027-03-27",
        "holiday": "easterSaturday",
        "holidayGroups": [
          "nonBanking",
          "holiday"
        ],
        "localName": "pääsiäislauantai",
        "name": "Easter Saturday"
      },
      "easterSunday": {
        "date": "2027-03-28",
        "holiday": "easterSunday",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "pääsiäispäivä",
        "name": "Easter Sunday"
      },
      "easterMonday": {
        "date": "2027-03-29",
        "holiday": "easterMonday",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "2. pääsiäispäivä",
        "name": "Easter Monday"
      },
      "mayDay": {
        "date": "2027-05-01",
        "holiday": "mayDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "vappu",
        "name": "May Day"
      },
      "ascensionDay": {
        "date": "2027-05-06",
        "holiday": "ascensionDay",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "helatorstai",
        "name": "Ascension Day"
      },
      "pentecost": {
        "date": "2027-05-16",
        "holiday": "pentecost",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "helluntaipäivä",
        "name": "Pentecost"
      },
      "midsummerEve": {
        "date": "2027-06-25",
        "holiday": "midsummerEve",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "juhannusaatto",
        "name": "Midsummer Eve"
      },
      "midsummerDay": {
        "date": "2027-06-26",
        "holiday": "midsummerDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "juhannuspäivä",
        "name": "Midsummer Day"
      },
      "allSaintsDay": {
        "date": "2027-11-20",
        "holiday": "allSaintsDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "pyhäinpäivä",
        "name": "All Saints' Day"
      },
      "independenceDay": {
        "date": "2027-12-06",
        "holiday": "independenceDay",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "itsenäisyyspäivä",
        "name": "Independence Day"
      },
      "christmasEve": {
        "date": "2027-12-24",
        "holiday": "christmasEve",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "jouluaatto",
        "name": "Christmas Eve"
      },
      "christmasDay": {
        "date": "2027-12-25",
        "holiday": "christmasDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "joulupäivä",
        "name": "Christmas Day"
      },
      "stStephensDay": {
        "date": "2027-12-26",
        "holiday": "stStephensDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "2. joulupäivä",
        "name": "St. Stephen's Day"
      }
    }
  },
  {
    "year": 2028,
    "holidays": {
      "newYearsDay": {
        "date": "2028-01-01",
        "holiday": "newYearsDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "uudenvuodenpäivä",
        "name": "New Year's Day"
      },
      "epiphany": {
        "date": "2028-01-06",
        "holiday": "epiphany",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "loppiainen",
        "name": "Epiphany"
      },
      "goodFriday": {
        "date": "2028-04-14",
        "holiday": "goodFriday",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "pitkäperjantai",
        "name": "Good Friday"
      },
      "easterSaturday": {
        "date": "2028-04-15",
        "holiday": "easterSaturday",
        "holidayGroups": [
          "nonBanking",
          "holiday"
        ],
        "localName": "pääsiäislauantai",
        "name": "Easter Saturday"
      },
      "easterSunday": {
        "date": "2028-04-16",
        "holiday": "easterSunday",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "pääsiäispäivä",
        "name": "Easter Sunday"
      },
      "easterMonday": {
        "date": "2028-04-17",
        "holiday": "easterMonday",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "2. pääsiäispäivä",
        "name": "Easter Monday"
      },
      "mayDay": {
        "date": "2028-05-01",
        "holiday": "mayDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "vappu",
        "name": "May Day"
      },
      "ascensionDay": {
        "date": "2028-05-25",
        "holiday": "ascensionDay",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "helatorstai",
        "name": "Ascension Day"
      },
      "pentecost": {
        "date": "2028-06-04",
        "holiday": "pentecost",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "helluntaipäivä",
        "name": "Pentecost"
      },
      "midsummerEve": {
        "date": "2028-06-23",
        "holiday": "midsummerEve",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "juhannusaatto",
        "name": "Midsummer Eve"
      },
      "midsummerDay": {
        "date": "2028-06-24",
        "holiday": "midsummerDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "juhannuspäivä",
        "name": "Midsummer Day"
      },
      "allSaintsDay": {
        "date": "2028-11-25",
        "holiday": "allSaintsDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "pyhäinpäivä",
        "name": "All Saints' Day"
      },
      "independenceDay": {
        "date": "2028-12-06",
        "holiday": "independenceDay",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "itsenäisyyspäivä",
        "name": "Independence Day"
      },
      "christmasEve": {
        "date": "2028-12-24",
        "holiday": "christmasEve",
        "holidayGroups": [
          "official",
          "holiday"
        ],
        "localName": "jouluaatto",
        "name": "Christmas Eve"
      },
      "christmasDay": {
        "date": "2028-12-25",
        "holiday": "christmasDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "joulupäivä",
        "name": "Christmas Day"
      },
      "stStephensDay": {
        "date": "2028-12-26",
        "holiday": "stStephensDay",
        "holidayGroups": [
          "official",
          "nonBanking",
          "holiday"
        ],
        "localName": "2. joulupäivä",
        "name": "St. Stephen's Day"
      }
    }
  }
] as any as YearlyHolidays[];
